import { Component } from '@angular/core';
import { BreadcrumbComponent } from '@spartacus/storefront';

@Component({
    selector: 'app-uig-breadcrumb',
    templateUrl: './uig-breadcrumb.component.html',
    styleUrls: ['./uig-breadcrumb.component.scss'],
    standalone: false
})
export class UigBreadcrumbComponent extends BreadcrumbComponent {


}
